import { useEffect, useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { Datatable } from '../../component/Datatable/Datatable';
import { GridColDef } from '@mui/x-data-grid';

import './Sale.scss';
import { LocalizationProvider, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { IconButton, TextField, Tooltip } from '@mui/material';
import axios from 'axios';
import { Delete, Edit } from '@mui/icons-material';

const columns: GridColDef[] = [
  { field: 'id', headerName: 'ID', width: 70 },
  { field: 'code', headerName: 'Код', width: 130 },
  { field: 'title', headerName: 'Назва товару', width: 130 },
  { field: 'price', headerName: 'Ціна', width: 130 },
  { field: 'date', headerName: 'Дата', width: 130 },
  {
    field: 'action',
    headerName: 'Дії',
    width: 100,
    renderCell: (row) => {
      return (
        <>
          <div className="cellAction">
            <Tooltip title="Редагувати">
              <IconButton>
                <Edit className="editButton" />
              </IconButton>
            </Tooltip>
            <Tooltip title="Видалити">
              <IconButton
                onClick={() => {
                  // const authorizationToken = localStorage.getItem('token');
                  axios
                    .delete(`https://api.womans-choice.com.ua/admin/sale/${row.id}`)
                    // , {
                    //   headers: {
                    //     Authorization: `${authorizationToken}`
                    //   }
                    // })
                    .catch((error) => {});
                }}
              >
                <Delete className="deleteButton" />
              </IconButton>
            </Tooltip>
          </div>
        </>
      );
    }
  }
];

// let rows = [
//   { id: 1, code: '1000', title: 'Кофта біла', price: 250, date: '2022-09-13' },
//   { id: 2, code: '1001', title: 'Блузка', price: 650, date: '2022-09-15' },
//   { id: 3, code: '1002', title: 'Блузка', price: 450, date: '2022-09-17' }
// ];

const Sale: React.FunctionComponent = () => {
  const [value, setValue] = useState<Dayjs | null>(dayjs('2014-08-18'));

  const [rows, setRows] = useState([]);

  const handleChange = (newValue: Dayjs | null) => {
    setValue(newValue);
  };
  useEffect(() => {
    axios
      .post('https://api.womans-choice.com.ua/admin/sale/filter')
      .then((res) => {
        console.log(res.data.data);
        setRows(res.data.data);
      })
      .catch((error) => {
        // console.log(error);
      });
  }, []);
  return (
    <>
      <div className="admin-sale-filter">
        <div className="filterItem">
          <p id="size" className="title">
            Розміри
          </p>
          <ul>
            <li>XS</li>
            <li>S</li>
            <li>M</li>
            <li>L</li>
            <li>XL</li>
            <li>XXL</li>
          </ul>
        </div>
        <div className="filterItem">
          <p id="type" className="title">
            Тип
          </p>
          <ul>
            <li>Блузка</li>
            <li>Кофта</li>
            <li>Гольф</li>
            <li>Кардіган</li>
          </ul>
        </div>
        <div className="filterItem">
          <p id="saleDate" className="title">
            День продажу
          </p>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker label="Date mobile" inputFormat="YYYY-MM-DD" value={value} onChange={handleChange} renderInput={(params) => <TextField {...params} />} />
          </LocalizationProvider>
        </div>
      </div>
      <Datatable columns={columns} rows={rows} />
    </>
  );
};

export { Sale };
